import type { MembershipDetails } from '../../entities/entityTypes';
import { requestBuilder } from '../../http/RequestBuilder';
import type { GeneralResponse } from '../../http/types/Common';
import { useRefetchGetMembershipMoneyMapsMutationOptions } from './useRefetchGetMembershipMoneyMapsMutationOptions';

const useDeleteMoneyMap = requestBuilder.mutation<
    GeneralResponse,
    null,
    { id: string }
>({
    endpoint: ({ id }) => `/api/admin/money-map/${id}`,
    method: 'DELETE',
});

export const useDeleteMoneyMapAndRefetch = (
    membership: MembershipDetails | null,
) => {
    const refetchMembershipMutationOptions =
        useRefetchGetMembershipMoneyMapsMutationOptions(membership);

    const { mutateAsync } = useDeleteMoneyMap(refetchMembershipMutationOptions);

    const deleteMoneyMapAsync = async (id: string) => {
        return await mutateAsync({
            urlParams: {
                id,
            },
        });
    };

    return {
        deleteMoneyMapAsync,
    };
};
